import type { CompanyResponse } from '@shared/schemas';

import type { EnrichStatus, LoadStatus, TeamMember } from '../../_shared/domain/company-detail.model';

/** Enrichment lifecycle (`error` holds the failure snackbar message). */
export interface EnrichState {
  status: EnrichStatus;
  error: string | null;
}

/**
 * Redux state for the client Institutional Detail page. The slice owns the loaded
 * company, the lazily-loaded team (its own load lifecycle), and the enrichment
 * lifecycle. Ephemeral UI (active tab, the force-refresh dialog) stays local to
 * the page. Every field is serialisable.
 */
export interface InstitutionalDetailState {
  company: CompanyResponse | null;
  loadStatus: LoadStatus;
  team: TeamMember[];
  teamStatus: LoadStatus;
  enrich: EnrichState;
}

export const emptyEnrich: EnrichState = { status: 'idle', error: null };

export const initialState: InstitutionalDetailState = {
  company: null,
  loadStatus: 'idle',
  team: [],
  teamStatus: 'idle',
  enrich: emptyEnrich,
};
